import gql from 'graphql-tag';

export const GET_INDIVIDUAL_REGIONS_QUERY = gql`
	query GetRegions($q: JSON!, $limit: Int, $offset: Int) {
		regions(query: $q, limit: $limit, offset: $offset) {
			id
			name
			latitude
			longitude
			infoPath
			regionConfig {
				id
				name
				coldwellPackages
				lightingOptions
			}
			flexBookingDelayTime
			timezone
			state
			options {
				id
				packageType
				name
				quantity
				price
				coverFile {
					id
					thumbnailUrl
				}
			}
			regionalManager {
				id
				image
				name
				email
				phoneNumber
			}
			zipCodes
			timezone
		}
	}
`;
